module.exports = __webpack_public_path__ + "static/media/masthead-subpage.c6cf27c0.svg";